import React from "react";
import XDrawer from "@mui/material/Drawer";
import { Box } from "@mui/material";
import { isMobile } from "utils/platform.utils";

const Drawer = ({ PaperProps, ...props }) => {
  const showSafeArea = isMobile();

  // Extract padding to apply to the content wrapper on mobile
  const paperSx = PaperProps?.sx || {};
  const { p, padding, pt, paddingTop, pb, paddingBottom } = paperSx;

  const contentPadding = {
    p,
    padding,
    pt,
    paddingTop,
    pb,
    paddingBottom,
  };

  return (
    <XDrawer
      PaperProps={{
        ...PaperProps,
        sx: {
          ...PaperProps?.sx,
          ...(showSafeArea && {
            display: "flex",
            flexDirection: "column",
            // Reset vertical paddings on Paper itself so safe-area bands are edge-to-edge
            paddingTop: 0,
            paddingBottom: 0,
            padding: undefined,
            p: undefined,
            pt: undefined,
            pb: undefined,
          }),
        },
      }}
      {...props}
    >
      {showSafeArea && (
        <Box
          sx={{
            flexShrink: 0,
            width: "100%",
            height: "env(safe-area-inset-top, 0px)",
            backgroundColor: "#000000",
          }}
        />
      )}

      {showSafeArea ? (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            ...contentPadding,
          }}
        >
          {props.children}
        </Box>
      ) : (
        props.children
      )}

      {showSafeArea && (
        <Box
          sx={{
            flexShrink: 0,
            width: "100%",
            height: "env(safe-area-inset-bottom, 0px)",
            backgroundColor: "#000000",
          }}
        />
      )}
    </XDrawer>
  );
};

export default Drawer;
